import { ACCOUNT_CREATION_REQUEST_BASE_URL, CONTACT_US_BASE_URL } from '../utils/ApiUrls';



class ContactUsService {
  async contactUs(contactData) {
    try {
      const response = await fetch(CONTACT_US_BASE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(contactData)
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.error || data.detail || 'Failed to send contact informations',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  async accountCreationRequest(requestData) {
    try {
      const response = await fetch(ACCOUNT_CREATION_REQUEST_BASE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.message || data.error || data.detail || 'Failed to send account creation request',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
        message: data.message,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }
}

// Export singleton instance
const contactUsService = new ContactUsService();
export default contactUsService;